import { render, staticRenderFns } from "./CheckGroup.vue?vue&type=template&id=0f2eaa4d"
import script from "./CheckGroup.vue?vue&type=script&lang=js"
export * from "./CheckGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports